// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileRowItem_wrapper__LnpUg","label":"MobileRowItem_label__8qeRg"};